export default __webpack_public_path__ + "static/media/RingRingHand.2deb8e17.png";